import { TFormSchema } from "@/comn/hooks";

/*
 * Anonymous Authentication Service
 * !== 익명 인증 서비스 ==!
 */
export const BASE = {
    api: `${process.env.REACT_APP_API_PTLE}`,
};

export const SF_ANY_AUTH: TFormSchema = {
      id: "form_anyAuth"
    , schema: {
          authTpCd : {
              type      : "select" , label     : "L_AUTH_TP"
            , area      : "comnCd" , comnCd    : "CGM0167"
            , labelSize : 5 , controlSize : 7 , required  : true
          }
        , id       : { type: "text"    , label: "L_ID", required: true, labelSize: 5, controlSize : 7 }
        , pwd      : {
            type: "password", label: "L_PWD", maxLength: 30, labelSize: 5, controlSize : 7, required: true
                , pattern: {
                    value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/
                    // Password must be at least 10 characters and include uppercase letters, lowercase letters, numbers, and special characters.
                    // !== 비밀번호는 10자 이상이어야 하며, 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다. ==!
                    , message: "msg.ptl.00761"
                }
        }
        , pwdCfrm: {
            type: "password", label: "L_PWD_CFRM", maxLength: 30, labelSize: 5, controlSize : 7, required: true
                , pattern: {
                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/
                      // Password must be at least 10 characters and include uppercase letters, lowercase letters, numbers, and special characters.
                      // !== 비밀번호는 10자 이상이어야 하며, 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다. ==!
                      , message: "msg.ptl.00761"
                }
        }
        , lgnTp  : { type: "radio"   , label: "L_AUTH_TP" , options: [{ label: "L_TIN", value: "1"}, {label: "L_PSPR_NO", value: "2" }], defaultValue: "1", labelSize: 5, controlSize : 7 }
    }
};


